import { useEffect, useRef, useState } from "react";
import { auth as firebaseUiAuth } from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { onAuthStateChanged, EmailAuthProvider } from "firebase/auth";
import { TOS_URL, PP_URL } from "config";

import { firebaseAuth as defaultFirebaseAuth } from "services/firebase";

const defaultUiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      return false; // Do not redirect or reload
    },
    uiShown: () => {},
  },
  signInOptions: [
    {
      provider: EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: false,
      disableSignUp: {
        status: true,
        adminEmail: "support@xyloplan.com",
      },
    },
  ],
  tosUrl: TOS_URL,
  privacyPolicyUrl: PP_URL,
};

const FirebaseAuthUi = ({
  uiConfig = defaultUiConfig,
  firebaseAuth = defaultFirebaseAuth,
}) => {
  const [userSignedIn, setUserSignedIn] = useState(false);
  const authUiElementRef = useRef(null);

  useEffect(() => {
    const firebaseUiWidget =
      firebaseUiAuth.AuthUI.getInstance() ||
      new firebaseUiAuth.AuthUI(firebaseAuth);

    // Track auth state to reset firebaseUi if the user signs out
    const unregisterAuthObserver = onAuthStateChanged(firebaseAuth, (user) => {
      if (!user && userSignedIn) firebaseUiWidget.reset();
      setUserSignedIn(!!user);
    });

    firebaseUiWidget.start(authUiElementRef.current, uiConfig);

    return () => {
      unregisterAuthObserver();
      firebaseUiWidget.reset();
    };
  }, [firebaseAuth, userSignedIn, uiConfig]);

  return <div ref={authUiElementRef} />;
};

export default FirebaseAuthUi;
